__turbopack_context__.v({
  "selectfield": "Selectfield-module-scss-module__Nz10Eq__selectfield",
});
